export default {
    model: {
        email: {
            label: "电子邮件",
            placeholder: "代表姓名或电子邮件",
            notFound: "未找到用户"
        },
        start_on: {
            label: "开始日期",
            placeholder: "开始委派的日期"
        },
        end_on: {
            label: "结束日期",
            placeholder: "选修的"
        },
        accept: {
            tip: "通过委托他人审批，您即证明您将对您的委托人批准的任何订单承担责任。",
            label: "我接受"
        }
    },
    buttons: {
        submit: {
            cta: "确认",
            processing: "保存"
        },
        close: {
            cta: "取消"
        }
    },
    saved: "已保存"
}